import React from 'react';
import { Glyphicon, Button, FormControl } from 'react-bootstrap';
import NewPlayer from './new-player';
import Ace from 'react-ace';
import FlowSource from '../../sources/flow';
import PlayerSource from '../../sources/player';
import { notificationTypes } from '../../constants';
import { addNotification } from '../../actions/reduxActions/notification';
import { connect } from 'react-redux';
import Loader from '../Loader';
import '../../../css/players.less';
import '../../../css/notification.less';

import 'brace/mode/html';
import 'brace/theme/twilight';

import { CSSTransitionGroup } from 'react-transition-group';
import translations from '../../translations';
import { stringReplace } from '../../utils/core';
import Confirm from '../generic/confirm';
import { Notifications } from '../notifications/Notifications';

export class Players extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isDeletePlayerModalVisible: false,
            isNewPlayerModalVisible: false,
            isPreviewVisible: false,
            html: '',
        };
    }

    componentDidMount() {
        this.getAll(this.props.tenantId, this.props.authenticationToken);
        this.select('');
        this.setState({ html: '' });
        this.loadFlows(this.props.tenantId);
    }

    toggleDeletePlayerModal = () => {
        this.setState({ isDeletePlayerModalVisible: !this.state.isDeletePlayerModalVisible });
    }

    toggleNewPlayerModal = () => {
        this.setState({ isNewPlayerModalVisible: !this.state.isNewPlayerModalVisible });
    }

    togglePreview = () => {
        this.setState({ isPreviewVisible: !this.state.isPreviewVisible });
    }

    onHtmlChange = (value) => {
        this.setState({ html: value, unSavedChanges: true });
    }

    onRefresh = () => {
        if (this.state.selectedPlayer) {
            this.get(this.state.selectedPlayer, this.props.tenantId);
            this.getAll(this.props.tenantId, this.props.authenticationToken);
        }
    }

    onPlayerSelected = (e) => {
        this.get(e.target.value, this.props.tenantId);
        this.select(e.target.value);
    }

    onFlowSelected = (e) => {
        this.setState({ selectedFlow: this.state.flows.filter(flow => flow.id === e.target.value)[0] });
    }

    onSavePlayer = () => {
        this.save(this.state.selectedPlayer, this.state.html, this.props.tenantId, this.props.authenticationToken);
    }

    onNewPlayer = (name, base) => {
        this.setState({ isNewPlayerModalVisible: false });
        this.new(name, base, this.props.tenantId, this.props.authenticationToken);
    }

    onDeletePlayer = (name) => {
        this.delete(name, this.props.tenantId, this.props.authenticationToken);
    }

    onFlowsLoaded(response) {
        if (response) {
            this.setState({
                flows: response.map(flow => ({ id: flow.id.id, versionId: flow.id.versionId, name: flow.developerName })),
            });
        }
        this.setState({ isLoading: false });
    }

    onError(response) {
        let message = response;
        if (typeof response === 'object') {
            ({ message } = response);
        }

        this.setState({ isLoading: false });

        this.props.addNotification({
            type: notificationTypes.ERROR,
            message,
            isPersistent: true,
        });
    }

    onGetAll(response) {
        this.setState({
            isLoading: false,
            players: response,
        });
    }

    onGet(response) {
        this.setState({
            isLoading: false,
            html: response,
            unSavedChanges: false,
        });
    }

    onSave(response) {
        this.setState({
            isLoading: false,
            html: response,
            unSavedChanges: false,
        });

        this.props.addNotification({
            type: notificationTypes.SUCCESS,
            message: 'Player saved successfully',
            isPersistent: false,
        });
    }

    onNew(response) {
        this.onSave(response);
    }

    onDelete() {
        this.setState({
            isLoading: false,
            html: null,
            selectedPlayer: '',
            isDeletePlayerModalVisible: false,
            unSavedChanges: false,
        });

        this.props.addNotification({
            type: notificationTypes.SUCCESS,
            message: 'Player deleted successfully',
            isPersistent: false,
        });
    }

    getAll(tenantId, authenticationToken) {
        this.setState({ isLoading: true });

        return PlayerSource.getAll(tenantId, authenticationToken)
            .then(response => this.onGetAll(response))
            .catch(response => this.onError(response));
    }

    select(player) {
        this.setState({ selectedPlayer: player });
    }

    loadFlows(tenantId) {
        this.setState({ isLoading: true });

        return FlowSource.getActivated(tenantId)
            .then(response => this.onFlowsLoaded(response))
            .catch(response => this.onError(response));
    }

    get(name, tenantId) {
        this.setState({ isLoading: true });

        return PlayerSource.get(name, tenantId)
            .then(response => this.onGet(response))
            .catch(response => this.onError(response));
    }

    save(name, html, tenantId, authenticationToken) {
        this.setState({ isLoading: true });

        return PlayerSource.save(name, encodeURIComponent(html), tenantId, authenticationToken)
            .then(response => this.onSave(response))
            .catch(response => this.onError(response));
    }

    new(name, basedOn, tenantId, authenticationToken) {
        this.setState({ isLoading: true });

        return PlayerSource.get(basedOn, tenantId)
            .then(response => PlayerSource.save(name, encodeURIComponent(response), tenantId, authenticationToken))
            .then(response => this.onNew(response))
            .then(() => PlayerSource.getAll(tenantId, authenticationToken))
            .then(response => this.onGetAll(response))
            .then(() => this.select(name))
            .catch(response => this.onError(response));
    }

    delete(name, tenantId, authenticationToken) {
        this.setState({ isLoading: true });

        return PlayerSource.delete(name, tenantId, authenticationToken)
            .then(() => PlayerSource.getAll(tenantId, authenticationToken))
            .then(response => this.onGetAll(response))
            .then(response => this.onDelete(response))
            .catch(response => this.onError(response));
    }

    render() {
        let playerOptions = [<option value="" disabled key="select-player">Select a player to edit</option>];
        let flowOptions = [<option value="" disabled key="select-flow">Select a flow to preview</option>];

        if (this.state.players) {
            playerOptions = playerOptions.concat(this.state.players.map(player => <option value={player} key={player}>{player}</option>));
        }
        if (this.state.flows) {
            flowOptions = flowOptions.concat(this.state.flows.map(flow => <option value={flow.id} key={flow.id}>{flow.name}</option>));
        }
        let preview = null;
        let previewStyle = 'info';
        let previewCaption = 'Preview';

        if (this.state.isPreviewVisible && this.state.selectedFlow) {
            const previewSrc = `/${this.props.tenantId}/play/${this.state.selectedPlayer}` +
                `?flow-id=${this.state.selectedFlow.id}&flow-version-id=${this.state.selectedFlow.versionId}`;
            preview = <iframe title="Player Preview" key={`${this.state.selectedPlayer}-preview`} seamless="seamless" src={previewSrc} />;
            previewStyle = 'danger';
            previewCaption = 'Close';
        }

        const previewButton = (
            <Button
                bsStyle={previewStyle}
                onClick={this.togglePreview}
                active={this.state.isPreviewVisible}
                disabled={!this.state.selectedPlayer || !this.state.selectedFlow}
            >
                {previewCaption}
            </Button>
        );
        const selectedFlowId = (this.state.selectedFlow != null) ? this.state.selectedFlow.id : null;

        const unSavedChanges = this.state.unSavedChanges ? (
            // Shows a persistent notification that cannot be closed when the player has unsaved changes
            // This notification does not use the global Notifications area but its own instance so that this notification only appears in this tab
            // isPersistent is false so the close button does not appear but this notification will not get cleared
            <Notifications notifications={[
                {
                    type: notificationTypes.INFO,
                    message: 'This player contains un-saved changes',
                    isPersistent: false,
                },
            ]}
            />
        ) : null;

        return (
            <div className="players">
                <div className="players-header">
                    <div className="player-controls">
                        <div className="player-select">
                            <FormControl
                                componentClass="select"
                                value={this.state.selectedPlayer}
                                onChange={this.onPlayerSelected}
                            >
                                {playerOptions}
                            </FormControl>
                        </div>
                        <div className="player-actions">
                            <Button bsStyle="primary" onClick={this.toggleNewPlayerModal}>
                                <Glyphicon glyph="plus" />
                                <span>New</span>
                            </Button>
                            <Button bsStyle="success" onClick={this.onSavePlayer} disabled={!this.state.selectedPlayer}>Save</Button>
                            <Button bsStyle="info" onClick={this.onRefresh} disabled={!this.state.selectedPlayer}>
                                <Glyphicon glyph="refresh" />
                                <span>Refresh</span>
                            </Button>
                            <Button bsStyle="danger" onClick={this.toggleDeletePlayerModal} disabled={!this.state.selectedPlayer}>Delete</Button>
                        </div>
                    </div>
                    <div className="player-preview">
                        <FormControl
                            componentClass="select"
                            value={selectedFlowId || ''}
                            onChange={this.onFlowSelected}
                        >
                            {flowOptions}
                        </FormControl>
                        {previewButton}
                    </div>
                </div>
                <Ace
                    readOnly={!this.state.selectedPlayer}
                    mode="html"
                    theme="twilight"
                    value={this.state.html}
                    width="auto"
                    height="auto"
                    name="player-editor"
                    onChange={this.onHtmlChange}
                />
                {this.state.isLoading ? <Loader /> : null}
                {
                    this.state.isNewPlayerModalVisible ?
                        <NewPlayer players={this.state.players} container={this} close={this.toggleNewPlayerModal} save={this.onNewPlayer} /> :
                        null
                }
                {unSavedChanges}

                <Confirm
                    show={this.state.isDeletePlayerModalVisible}
                    title={translations.PLAYER_delete_confirmation_title}
                    messages={[
                        stringReplace(translations.PLAYER_delete_confirmation_message, {
                            playerName: this.state.selectedPlayer,
                        }),
                        translations.GENERAL_cannot_be_undone,
                    ]}
                    buttonStyle="danger"
                    buttonCaption="Delete"
                    onCancel={this.toggleDeletePlayerModal}
                    onConfirm={() => this.onDeletePlayer(this.state.selectedPlayer)}
                    isInProgress={this.state.isLoading}
                />

                <CSSTransitionGroup
                    transitionName="player-preview"
                    className="player-preview-transition"
                    transitionEnterTimeout={1000}
                    transitionLeaveTimeout={1000}
                >
                    {preview}
                </CSSTransitionGroup>
            </div>
        );
    }

}

const mapDispatchToProps = {
    addNotification,
};

export default connect(
    ({ currentUser: { authenticationToken, tenantId } }) => ({ authenticationToken, tenantId }),
    mapDispatchToProps,
)(Players);
